import { extendServiceContainer } from '@iotize/tap';
import { EthernetService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    ethernet: EthernetService;
  }
}

export const _TAP_SERVICE_EXTENSION_ETHERNET_ = extendServiceContainer(
  'ethernet',
  EthernetService,
);
